// libraries
import $ from 'jquery';
import 'jquery-match-height';
import 'picturefill';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import 'magnific-popup';

import { Foundation } from 'foundation-sites/js/foundation.core';
import { Box } from 'foundation-sites/js/foundation.util.box';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';

import './components/cookie';

// vendor
import './vendor/magictoolbox/magiczoomplus';
import './vendor/magictoolbox/magicscroll';
import './vendor/fancyapp/fancybox/jquery.fancybox.min';

// polyfills
import './polyfills/closest';
import './polyfills/CustomEvent';
import './polyfills/Object';

// components
import './components/utils';
import toggler from './components/toggler';
import initToggleButtons from './components/toggleButton';
import clickRelay from './components/clickRelay';
import './components/buttons';
import initRangeSliders from './components/range';
import './components/header';
import './components/result-list';
import './components/slider';
import './components/fancybox';
import './components/breadcrumb';
import './components/accordion';
import './components/totoplink';
import './components/limiter';
import './components/collapsable';
import './components/site-settings';
import './components/reload-button';
import './components/remove-element';
import './components/print';
import './components/form-email2sender';
import './components/submit';
import './components/pagination';
import { initFilterForm, initFilterTags, filterDropdown } from './components/filter';
import './components/cookienotice';
import './components/magic-zoom';
import './components/download-selected';
import './components/ios';
import './components/conditionalFieldset';
import OffCanvas from './components/twt.off-canvas';
import Drilldown from './components/twt.drilldown';
import Menu from './components/twt.menu';
import Tabs from './components/tabs';
import * as TWTmediaQuery from './components/twt.media-query';
import pubSub from './components/pubSub';
import overlay from './components/overlay';
import './components/spinner';
import './components/wishlist';
import { updateWishlistBadge } from './components/wishlist-actions';
import './components/product-detail';
import './components/datepicker';
import initArticleListOrder from './components/article-list-order';
import manageSearchResultCategories from './components/searchresult-categories';
import initTruncateText from './components/truncate-text';
import { matchTeaserHeights, matchSliderHeights } from './components/match-height';

// svg4everybody
svg4everybody();

// images
objectFitImages();

// instanciate classes
const drilldownNodes = document.querySelectorAll('[data-drilldown]');
const drilldownInstances = [];
const menuNodes = document.querySelectorAll('[data-menu]');
const menuInstances = [];
const offCanvasNodes = document.querySelectorAll('[data-off-canvas]');
const OffCanvasInstances = [];
const tabsNodes = document.querySelectorAll('[data-tabs]');
const tabsInstances = [];

const blnIsTouchDevice = !!('ontouchstart' in window) || !!(navigator.msMaxTouchPoints);

document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

if (blnIsTouchDevice) {
  document.documentElement.classList.remove('no-touch');
  document.documentElement.classList.add('touch');
}

// Media Query
TWTmediaQuery.init();

// Drilldown
for (let i = 0; i < drilldownNodes.length; i += 1) {
  drilldownInstances.push(new Drilldown(drilldownNodes[i]));
}

// Menu
for (let i = 0; i < menuNodes.length; i += 1) {
  menuInstances.push(new Menu(menuNodes[i]));
}

// OffCanvas
for (let i = 0; i < offCanvasNodes.length; i += 1) {
  OffCanvasInstances.push(new OffCanvas(offCanvasNodes[i]));
}

// Tabs
for (let i = 0; i < tabsNodes.length; i += 1) {
  tabsInstances.push(new Tabs(tabsNodes[i]));
}

/**
 * Utils
 */
const deleteOptionsContainer = document.querySelector('.delete-option');
if (deleteOptionsContainer !== null) initFilterTags(deleteOptionsContainer);

initFilterForm();
toggler();
initToggleButtons();
clickRelay();
filterDropdown();
initArticleListOrder();
initRangeSliders();
initTruncateText();
matchTeaserHeights();
matchSliderHeights();
updateWishlistBadge();
$('.service-contact__name').matchHeight();

/**
 * Subscriptions
 */

// Off-canvas
pubSub.subscribe('opened.offCanvas', () => overlay.show());
pubSub.subscribe('closed.offCanvas', () => overlay.hide());

// Content reload
pubSub.subscribe('reloaded.content', (data) => {
  if (data.scope !== undefined) {
    const scope = data.scope;

    toggler(scope);
    initToggleButtons(scope);
    clickRelay(scope);
    filterDropdown(scope);
    $('.accordion').Accordion();
    initRangeSliders(scope);

    if (scope.parentNode.id === 'searchresult-1') manageSearchResultCategories();
  }

  // match height
  matchTeaserHeights();
});

// wenn die Suche geöffnet wird, soll der Focus auf dem Input gesetzt werden
const metaSearchButton = document.querySelector('.meta-search button');

if (metaSearchButton !== null) {
  metaSearchButton.addEventListener('click', () => {
    const search = document.getElementById('js-search');

    search.querySelector('input').focus();
  });
}

$(document).ready(() => {
  /**
   * Foundation
   * https://github.com/zurb/foundation-sites/blob/develop/js/entries/foundation.js
   */

  // add to jQuery
  Foundation.addToJquery($);

  // add to Foundation
  Foundation.Box = Box;
  Foundation.MediaQuery = MediaQuery;
  Foundation.Keyboard = Keyboard;

  // init utils
  Triggers.init($, Foundation);

  // Plugins
  Foundation.plugin(Tooltip, 'Tooltip');
  Foundation.plugin(Dropdown, 'Dropdown');

  $(document).foundation();

  /**
   * Magnific Popup
   * http://dimsemenov.com/plugins/magnific-popup/
   */
  $('.news-gallery').magnificPopup({
    type: 'image',
    delegate: 'a',
    gallery: {
      enabled: true,
      titleSrc: 'title',
    },
    verticalFit: true,
  });

  // Menu active state generation
  // ----------------------------
  const currentUid = $('body').data('uidCurrent');
  const $sidebar = $('.sidebar > .nav.nav--sidebar');
  const $breadcrumb = $('.nav.nav--breadcrumb');

  // eslint-disable-next-line func-names
  const generateMenuActiveStates = function (links = [], removeFirst = false) {
    // If list array is not empty
    if (links.length > 0) {
      // Remove first item
      if (removeFirst) links.shift();

      // Find the first mainNavigation item that matches the first item within
      // the links array
      let $selector = $('#mainNavigation')
        .find(`a[href="${links[0]}"]`).first().parent();

      // Add is--current class to the list item
      $selector.addClass('is--current');

      // Recursively find current child pages
      for (let index = 1; index < links.length; index = index + 1) {
        $selector = $selector.find(`a[href="${links[index]}"]`)
          .first().parent();
        $selector.addClass('is--current');
      }
    }
  };

  // If body has data-uid-current attribute (CMS)
  if (typeof currentUid !== 'undefined') {
    // Add is--current class to current page and all parent pages
    $(`[data-uid=${currentUid}]`)
      .addClass('is--current')
      .parentsUntil('#mainNavigation', 'li')
      .each(function () { // eslint-disable-line func-names
        $(this).addClass('is--current');
      });
  } else if ($sidebar.length > 0) {
    // Else if sidebar exists
    const $currentSidebarActiveLink = $sidebar.find('.nav__item.is--active');
    const links = [];

    // Add active menu item to the links array
    //
    // If mainNavigation is changed to absolute links, remove the replace
    // function or adjust the regular expression
    links.push($currentSidebarActiveLink.find('> a')
      .attr('href')
      .replace(/(https?):\/\/.+?\//, '/'));

    // Traverse tree upwards to find all parent list items of the active menu item
    $($currentSidebarActiveLink.parentsUntil('.sidebar > .nav.nav--sidebar',
      'li').find('> a').get().reverse(),
    ).each(function () { // eslint-disable-line func-names
      // Add all parent pages of the active link at the beginning of the links array
      links.unshift(
        // Remove protocol and domain name to get relative URLs, because the
        // mainNavigation contains only relative links
        //
        // If mainNavigation is changed to absolute links, remove the replace
        // function or adjust the regular expression
        $(this).attr('href').replace(/(https?):\/\/.+?\//, '/'),
      );
    });

    generateMenuActiveStates(links, false);
  } else if ($breadcrumb.length > 0) {
    // Else if breadcrumb exists
    const links = [];
    $breadcrumb.find('li.nav__item > a').each(function () { // eslint-disable-line func-names
      links.push($(this).attr('href').replace(/(https?):\/\/.+?\//, '/'));
    });

    // Remove first item from links array because it's the home link "/"
    generateMenuActiveStates(links, true);
  }
});




// WEBPACK FOOTER //
// ./assets/js/app.js